// extracted by mini-css-extract-plugin
export var category = "_ks-9";
export var categoryHeader = "_ks-e";
export var container = "_ks-0";
export var group = "_ks-a";
export var groupItems = "_ks-f";
export var groupSeparator = "_ks-j";
export var loading = "_ks-1";
export var noResults = "_ks-3";
export var placeholder = "_ks-2";
export var resultContent = "_ks-5";
export var resultIcon = "_ks-c";
export var resultItem = "_ks-g";
export var resultMeta = "_ks-8";
export var resultSubtitle = "_ks-7";
export var resultSuffix = "_ks-i";
export var resultTitle = "_ks-6";
export var resultsList = "_ks-4";
export var searchGroup = "_ks-d";
export var selected = "_ks-h";
export var subgroup = "_ks-b";